export const StorageConstants = {
  LOGIN_TIME: "@admin-login-time",
  LOGIN_TOKEN: "@admin-login-token",
  USED_ID: "@admin-user-id",
  USER_NAME: "@admin-user-name",
  MOBILE_NUMBER: "@admin-mobile-number",

  ARTIST_PAGE: "admin-artist-page",
  ARTIST_PER_PAGE: "admin-artist-per-page",

  KYC_PAGE: "admin-kyc-page",
  KYC_PER_PAGE: "admin-kyc-per-page",

  RECRUITER_PAGE: "admin-recruiter-page",
  RECRUITER_PER_PAGE: "admin-recruiter-per-page",

  ALL_AUDITION_PAGE: "admin-all-audition-page",
  ALL_AUDITION_PER_PAGE: "admin-all-audition-per-page",
  PAST_AUDITION_PAGE: "admin-past-audition-page",
  PAST_AUDITION_PER_PAGE: "admin-past-audition-per-page",
  ACTIVE_AUDITION_PAGE: "admin-active-audition-page",
  ACTIVE_AUDITION_PER_PAGE: "admin-active-audition-per-page",
  DRAFT_AUDITION_PAGE: "admin-draft-audition-page",
  DRAFT_AUDITION_PER_PAGE: "admin-draft-audition-per-page",
  CLOSED_AUDITION_PAGE: "admin-closed-audition-page",
  CLOSED_AUDITION_PER_PAGE: "admin-closed-audition-per-page",

  APP_VERSION: "app-version",
};
